import { Primitive, PrimitiveField } from '../fields/createPrimitiveField';
import { FieldValidator } from '../fields/validation';
import { ValidationError } from '../types';

/**
 * Создает валидатор, проверяющий, что значение присутствует
 * @param code код ошибки
 * @returns валидатор
 */
export function requiredValidator<
    Code extends string,
    FieldValue extends Primitive,
    FieldContextInput,
    FieldContext,
    FieldActions,
    FieldSelectors,
>(
    code: Code
): FieldValidator<
    PrimitiveField<FieldValue, ValidationError<Code>, FieldContextInput, FieldContext, FieldActions, FieldSelectors>
> {
    return (value, fieldApi) => {
        if (!value && value !== 0) {
            fieldApi.addValidationError({ code });
        }
    };
}
